import { keyframes } from "@chakra-ui/react";
import { ChakraStylesConfig } from "chakra-react-select";

import { colorMapping } from "adminComponents/theme/colors";
import { hoverStyles, pxToRem } from "adminComponents/utils";

const fadeIn = keyframes`
0% {
  opacity: 0;
  transform: translateY(-5%);
}
100% {
  opacity: 1;
  transform: translateY(0);
}
`;

const animation = `${fadeIn} 250ms`;

const dropdownStyles: ChakraStylesConfig = {
  clearIndicator: (provided) => ({
    ...provided,
    display: "none",
  }),
  control: (provided, state) => ({
    // input
    ...provided,
    backgroundColor: "primary.white",
    borderTopRadius: ".5rem",
    borderBottomLeftRadius: state.menuIsOpen ? 0 : ".5rem",
    borderBottomRightRadius: state.menuIsOpen ? 0 : ".5rem",
    borderColor: "primary.medium-gray",
    color: "primary.warm-black",
    minHeight: pxToRem(48),
    padding: pxToRem(1),
    // adds 1px of padding for non-focus state to account for missing 1px of border
    _focus: {
      border: `${pxToRem(2)} solid ${colorMapping["utility.focus"]}`,
      padding: 0,
    },
    _invalid: {
      borderColor: "utility.error",
    },
    _disabled: {
      opacity: 0.5,
    },
    textStyle: "adminP2",
  }),
  downChevron: (provided, { selectProps }) => ({
    ...provided,
    color: "primary.warm-black",
    fontSize: "1.125rem",
    transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    bg: "transparent",
  }),
  indicatorSeparator: () => ({
    // vertical line between imput text and chevron
    display: "none",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: pxToRem(5),
  }),
  menuList: (provided) => ({
    ...provided,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    borderColor: "primary.golden",
    minWidth: "unset",
  }),
  menu: (provided) => ({
    ...provided,
    my: 0,
    border: `${pxToRem(2)} solid ${colorMapping["utility.focus"]}`,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTopWidth: 0,
    borderBottomRadius: ".5rem",
    animation: animation,
  }),
  multiValue: (provided) => ({
    // tag
    ...provided,
    bg: "primary.light-gray",
    borderRadius: "0.5rem",
  }),
  multiValueLabel: (provided) => ({
    // tag text
    ...provided,
    color: "primary.warm-black",
    textStyle: "adminP2",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    marginLeft: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    color: "primary.warm-black",
    bg: () => {
      if (state.isSelected && state.isFocused) {
        return "primary.golden-light";
      } else if (state.isSelected) {
        return "primary.light-gray";
      } else if (state.isFocused) {
        return "primary.golden-light";
      } else {
        return "transparent";
      }
    },
    textStyle: "adminP2",
    _hover: hoverStyles({
      bg: "primary.golden-light",
    }),
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "primary.dark-gray",
    textStyle: "adminP2",
    paddingLeft: "0.5rem",
  }),
  singleValue: (provided) => ({
    ...provided,
    paddingLeft: "0.5rem",
  }),
};

export { dropdownStyles };
